import React, { Fragment, useState, useRef } from 'react'
import { Helmet } from 'react-helmet'
import CookieConsent from 'react-cookie-consent'
import { Link } from 'react-router-dom'


//components
import ThemeMenuOne from '../../components/header/ThemeMenuOne'
import FeatureThree from '../../components/feature/FeatureThree'
import BlockStylFive from '../../components/block/BlockStylFive'
import MarqueSlider from '../../components/marque/MarqueSlider'
import FooterTwo from '../../components/footer/FooterTwo'
//modal video
import ModalVideos from '../../components/modal-video/ModalVideos'
import ThemeBannerThree from '../../components/theme-banner/ThemeBannerThree'
import FeatureFour from '../../components/feature/FeatureFour'

const SoftwareDevelopment = () => {
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }

    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper"  >
                <Helmet >
                    <title>Cruxestack</title>
                </Helmet>
                <ThemeMenuOne />
                <ThemeBannerThree />
                <MarqueSlider />
                <section className="techy-feature pt-150 pb-30 pt-lg-120">
                    <div className="container">
                <FeatureThree />
                    </div>
                </section>

                <section className="techy-feature pt-150 pb-30 pt-lg-120">
                    <div className="container">
                       <div className="section-title text-center mb-55">
                            <h2 className="sect-title">Our Services</h2>
                        </div>
                <FeatureFour />
                    </div>
                </section>


                <section className="techy-wrok-process pt-140 pb-30 pt-lg-55">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">Working Process</h6>
                                    <h2 className="sect-title">How It Works</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xl-7 col-lg-6">
                                <div className="process-img-wrapper mb-45">
                                    <img src="assets/img/work/process-1b.jpg" alt="img" />
                                    <div className="call-box">
                                        <div className="icon">
                                            <img src="assets/img/icon/icon-27b.svg" alt="icon" />
                                        </div>
                                        <h3 className="sect-title-two">Do you have
                                            any question?</h3>
                                        <h4 className="fs-24 text-uppercase text-theme fw-medium">+90 565 74 44</h4>
                                        <h4 className="fs-24 text-uppercase text-theme fw-medium">+49 152 52387362</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <BlockStylFive />

                            </div>
                        </div>
                    </div>
                </section>
                <FooterTwo />                
                <CookieConsent
                    debug={false}
                    location="bottom"
                    style={{
                        background: "#913bff",
                        fontSize: "90%",
                        alignItems: "center",
                        zIndex: 10002,
                        border: '1px solid',
                        borderRadius: '20px'
                    }}
                    buttonStyle={{
                        color: "#913bff",
                        backgroundColor: 'white',
                        borderRadius: '15px',
                        border: '1px solid',
                    }}
                    buttonText="Accept"
                    expires={150}
                >
                    We use cookies to provide necessary site functionality, to provide the best possible user experience,
                    and to tailor future communications.<br /> By using this website you accept the use of cookies.
                    &nbsp;You can access our&nbsp;<Link style={{ color: '#00FFFF' }} to="/privacy"><u> Privacy Policy</u>
                    </Link>&nbsp;here
                </CookieConsent>
            </div>
        </Fragment>
    )
}

export default SoftwareDevelopment